exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "._1mDwlhwBbmFPZOhrQHdJN2{display:inline-block;width:16px;height:16px;line-height:16px;vertical-align:-20%}._1mDwlhwBbmFPZOhrQHdJN2+span{margin-left:3px}._1mDwlhwBbmFPZOhrQHdJN2 svg{display:block}._1mDwlhwBbmFPZOhrQHdJN2._3gCn968fQb-cXmwoPbjTjs,._1mDwlhwBbmFPZOhrQHdJN2._3gCn968fQb-cXmwoPbjTjs svg.WYywrYcqx64yCtdhjgpt0,._1mDwlhwBbmFPZOhrQHdJN2._3gCn968fQb-cXmwoPbjTjs svg path{fill:currentColor}", ""]);

// exports
exports.locals = {
	"icon": "_1mDwlhwBbmFPZOhrQHdJN2",
	"colorized": "_3gCn968fQb-cXmwoPbjTjs",
	"rect": "WYywrYcqx64yCtdhjgpt0"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/icon/icon.css
// module id = 286
// module chunks = 0 1 2